import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../../utils/mobileDetection';

const colorVariants = {
  rose: {
    from: "from-pink-100",
    to: "to-pink-200",
    hoverFrom: "hover:from-pink-50",
    hoverTo: "hover:to-pink-100",
    text: "text-pink-800",
  },
  sky: {
    from: "from-blue-100",
    to: "to-blue-200",
    hoverFrom: "hover:from-blue-50",
    hoverTo: "hover:to-blue-100",
    text: "text-blue-800",
  },
  mint: {
    from: "from-green-100",
    to: "to-green-200",
    hoverFrom: "hover:from-green-50",
    hoverTo: "hover:to-green-100",
    text: "text-green-800",
  },
  peach: {
    from: "from-orange-100",
    to: "to-orange-200",
    hoverFrom: "hover:from-orange-50",
    hoverTo: "hover:to-orange-100",
    text: "text-orange-800",
  },
  lavender: {
    from: "from-purple-100",
    to: "to-purple-200",
    hoverFrom: "hover:from-purple-50",
    hoverTo: "hover:to-purple-100",
    text: "text-purple-800",
  },
};

const PastelButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  color = "rose",
  className = "",
  animate = true,
  ...props
}) => {
  const isMobile = useIsMobile();
  const { from, to, hoverFrom, hoverTo, text } = colorVariants[color] || colorVariants.rose;

  // Configure motion props based on device type
  const getMotionProps = () => {
    if (disabled || !animate) {
      return {}; // No animations when disabled or animate is false
    }

    if (isMobile) {
      // Mobile: Only tap feedback, no hover
      return {
        whileTap: { scale: 0.95 },
        transition: { duration: 0.1, ease: "easeOut" }
      };
    } else {
      // Desktop: Both hover and tap feedback
      return {
        whileHover: { scale: 1.02 },
        whileTap: { scale: 0.98 },
        transition: { duration: 0.2, ease: "easeOut" }
      };
    }
  };

  const buttonContent = (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        rounded-full px-5 py-3 text-base font-medium 
        shadow-md transition-all duration-200 ease-in-out 
        bg-gradient-to-b ${from} ${to} ${text} 
        ${hoverFrom} ${hoverTo} hover:shadow-lg 
        disabled:opacity-50 disabled:cursor-not-allowed 
        h-11 flex items-center justify-center
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );

  // Return with or without motion wrapper based on animate prop
  if (animate) {
    return (
      <motion.div className="inline-block" {...getMotionProps()}>
        {buttonContent}
      </motion.div>
    );
  }

  return buttonContent;
};

export default PastelButton;
